import React = require("react");

import InfoView from "./views/InfoView";
import StatusView from "./views/StatusView";

import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import RaisedButton from "material-ui/RaisedButton";
import diyLightTheme = require("diy/material-ui/diyLightTheme");

export interface ButtonConfig {
    label: string;
    callback?: () => void;
}

interface InfoDialogProps extends React.Props<InfoDialog> {
    title?: string;
    status?: string;
    imageUrl?: string;
    imageHeight?: number;
    primaryButtonConfig?: ButtonConfig;
    secondaryButtonConfig?: ButtonConfig;
}

interface SuccessDialogState {
    open: boolean;
}

export default class InfoDialog extends React.Component<InfoDialogProps, SuccessDialogState> {

    static childContextTypes: React.ValidationMap<any> = {
        muiTheme: React.PropTypes.object
    };

    constructor(props: InfoDialogProps) {
        super(props);

        this.state = {
            open: false
        };

        jQuery(document).on("mousedown", "#cc-sa-item-updateTariff", () => {
            this.setState({
                open: false
            });
        });
    }

    /** Function to close the dialog */
    handleClose: () => void = () => {
        this.setState({
            open: false
        });
    };

    /** Callback function on the dialog's action button */
    handleCustomActionCallback: () => void = () => {
        this.handleClose();
        if (typeof this.props.primaryButtonConfig.callback === "function") {
            this.props.primaryButtonConfig.callback();
        }
    };

    /** Callback function on the dialog's close button */
    handleCloseActionCallback: () => void = () => {
        this.handleClose();
        if (typeof this.props.secondaryButtonConfig.callback === "function") {
            this.props.secondaryButtonConfig.callback();
        }
    };

    /** Theme customization for the component */
    getChildContext() {
        return {
            muiTheme: diyLightTheme
        };
    }

    /** Loading of the dialog */
    componentDidMount() {
        this.setState({
            open: true
        });
    }

    /** Closing of the dialog */
    componentWillUnmount() {
        this.handleClose();
    }

    /** Renderer */
    render() {
        let actions: Array<React.ReactElement<any>> = [];
        let paddingTop = this.props.imageHeight ? this.props.imageHeight + "px" : "40px";
        let backgroundImage = this.props.imageUrl ? "url('" + this.props.imageUrl + "')" : "none";

        let style = {
            zIndex: diy.editor.getNewTopZIndex()
        };
        let dialogStyle = {
            padding: 0
        };
        let bodyStyle = {
            padding: paddingTop + " 40px 30px 40px",
            backgroundImage: backgroundImage,
        };

        let view: JSX.Element;
        if (!this.props.status) {
            view = (
                <InfoView title={this.props.title} style={bodyStyle}>
                    {this.props.children}
                </InfoView>
            );
        } else {
            view = (
                <StatusView title={this.props.title} status={this.props.status} style={bodyStyle}>
                    {this.props.children}
                </StatusView>
            );
        }

        if (this.props.secondaryButtonConfig) {
            actions.push(
                <FlatButton
                    data-test="successDialogCloseAction"
                    label={this.props.secondaryButtonConfig.label}
                    onTouchTap={this.handleCloseActionCallback} />
            );
        }
        if (this.props.primaryButtonConfig) {
            actions.push(
                <RaisedButton
                    primary={true}
                    data-test="successDialogCustomAction"
                    label={this.props.primaryButtonConfig.label}
                    onTouchTap={this.handleCustomActionCallback} />
            );
        }

        return (
            <Dialog open={this.state.open}
                    actions={actions}
                    actionsContainerClassName="dialog-actions"
                    contentClassName="diy-material-info-dialog"
                    bodyStyle={dialogStyle}
                    style={style}>

                {view}
            </Dialog>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/info-dialog/InfoDialog.tsx
 **/